import { ContainerModule } from 'inversify';
import * as State from './state';
import * as Service from './service';
import * as Dsl from './dsl'
import { PlayerModuleSymbol } from '../api';
import { ExamPlayerModule } from './exam-player-module';

const examModule = new ContainerModule((bind) => {
  bind(PlayerModuleSymbol).to(ExamPlayerModule)
});

export const examModules = [
  examModule,
  Service.examResultServiceModule,
  State.examResultStateModule,
  Dsl.examDslRuntimeModule
]
